module.exports = __webpack_public_path__ + "static/media/30OIOS9.7fe00678.jpg";